import Button from "../../components/common/button/button";
import iDuck from "../../assets/icons/hero/pink_duck.webp";
import iBgRight from "../../assets/img/not-found-page/not-found-page-bg-right.svg";
import iBgLeft from "../../assets/img/not-found-page/not-found-page-bg-left.svg";
import iWaveFront from "../../assets/img/not-found-page/wave-front.svg";
import iWaveMid from "../../assets/img/not-found-page/wave-mid.svg";
import iWaveBack from "../../assets/img/not-found-page/wave-back.svg";
import { useNavigate } from "react-router-dom";
import { paths } from "../../routes/paths";
import "./not-found-page.sass";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page not-found-page">
      <div className="not-found-page__block">
        <div className="not-found-page__title">
          Упс, такой страницы не существует
        </div>

        <div className="not-found-page__text">Эта страница куда-то уплыла</div>

        <Button
          onClick={() => navigate(paths.MainPage)}
          className="not-found-page__button"
        >
          На главную
        </Button>
      </div>

      <img src={iDuck} className="img-absolute not-found-page__duck" alt="" />

      <img
        src={iWaveFront}
        className="img-absolute not-found-page__wave-front"
        alt=""
      />
      <img
        src={iWaveMid}
        className="img-absolute not-found-page__wave-mid"
        alt=""
      />
      <img
        src={iWaveBack}
        className="img-absolute not-found-page__wave-back"
        alt=""
      />

      <img
        src={iBgRight}
        className="img-absolute not-found-page__bg-right"
        alt=""
      />
      <img
        src={iBgLeft}
        className="img-absolute not-found-page__bg-left"
        alt=""
      />
    </div>
  );
};

export default NotFoundPage;
